'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var c3 = require('c3');

var C3Wrapper = function (_React$Component) {
  _inherits(C3Wrapper, _React$Component);

  function C3Wrapper() {
    _classCallCheck(this, C3Wrapper);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  C3Wrapper.prototype._updateC3 = function _updateC3(props) {
    props.config.bindto = this._container;
    if (this._chart) {
      this._chart.destroy();
    }
    this._chart = c3.generate(props.config);
  };

  C3Wrapper.prototype.componentDidMount = function componentDidMount() {
    this._updateC3(this.props);
  };

  C3Wrapper.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    this._updateC3(props);
  };

  C3Wrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    this._chart.destroy();
  };

  C3Wrapper.prototype.render = function render() {
    var _this2 = this;

    return React.createElement('div', { ref: function ref(c) {
        return _this2._container = c;
      } });
  };

  return C3Wrapper;
}(React.Component);

C3Wrapper.propTypes = {
  config: React.PropTypes.object.isRequired
};

module.exports = C3Wrapper;